import { requiredStrategy } from '../core';

const barcodeStartStrategy = (str: string) => {
  return !!str.match('/[0-9A-Z+-.]+');
};

const barcodeContentStrategy = (str: string) => {
  return !!str.match('[0-9A-Z+-.]{7}$');
};

const barcodeLengthStrategy = (str: string) => {
  return str.length === 8;
};

const barcodeContentLengthStrategy = (str: string) => {
  return str.length === 7;
};

/**
 * 檢查完整共通載具條碼，需要以 / 開頭，並有可用字元包含 0-9, A-Z, +, -, . 共 7 碼
 *
 * @param {string} str - The barcode value to be validated.
 * @returns {boolean} - Returns `true` if the barcode meets all validation rules, otherwise `false`.
 */
const barcodeCarrierStrategy = (str: string) => {
  return (
    requiredStrategy(str) &&
    barcodeStartStrategy(str) &&
    barcodeContentStrategy(str) &&
    barcodeLengthStrategy(str)
  );
};

/**
  * 檢查完整共通載具條碼內容(忽略前方 /)，有可用字元包含 0-9, A-Z, +, -, . 共 7 碼

  * @param {string} str - The barcode value to be validated.
  * @returns {boolean} - Returns `true` if the barcode meets all validation rules, otherwise `false`.
 */
const barcodeCarrierContentOnlyStrategy = (str: string) => {
  return (
    requiredStrategy(str) &&
    barcodeContentStrategy(str) &&
    barcodeContentLengthStrategy(str)
  );
};

export {
  barcodeCarrierContentOnlyStrategy,
  barcodeCarrierStrategy,
  barcodeContentLengthStrategy,
  barcodeContentStrategy,
  barcodeLengthStrategy,
  barcodeStartStrategy,
};
